import { useMutation, useQueryClient } from 'react-query'

import { impactPeriodService } from 'src/services/impact-period.service'
import { initialImpactPeriodsFilter } from './use-impact-periods.hook'
import { IImpactPeriodsRespDto } from 'src/types'

import { QUERY_KEYS } from 'src/constants'

const useUpdateImpactPeriodsOrder = () => {
  const queryClient = useQueryClient()

  return useMutation((ids: string[]) => impactPeriodService.updateImpactPeriodsOrder(ids), {
    onMutate(ids) {
      queryClient.setQueryData(
        [QUERY_KEYS.IMPACT_PERIODS, initialImpactPeriodsFilter],
        (prev?: IImpactPeriodsRespDto) => {
          if (!prev) return []

          return ids.map((id) => prev.find((item) => item.id === id)!)
        },
      )
    },
  })
}

export { useUpdateImpactPeriodsOrder }
